import store from './redux/store';
import HttpClient from './myapi';
import { bkupCategories } from './redux/actions';

const getCategories = (refresh) => {
    return new Promise((resolve, reject) => {
        const bkup = store.getState().allCats;
        if (bkup.length && !refresh) {
            resolve(bkup);
        } else {
            HttpClient.get('/getCategory.php').then(res =>{
                store.dispatch(bkupCategories(res));
                resolve(res);
            })
        }
    })
}

export const $Category = {
    getCategories: getCategories
}


// WEBPACK FOOTER //
// ./src/Middleware.js